import LoginHistoryItemDTO from 'dto/LoginHistoryItemDTO';
import moment from 'moment';
import api, { source } from 'utils/axios';

export default {
  source,
  createFolder: async (values) => {
    return await api.post('/classes/createFolder', values);
  },
  createClass: async (values) => {
    return await api.post('/classes/addClass', values);
  },
  editClass: async (values) => {
    return await api.post('/classes/editClass', values);
  },
  changeFolder: async (values) => {
    return await api.post('/classes/changeFolder', values);
  },
  deleteFolder: async (values) => {
    return await api.post('/classes/deleteFolder', values);
  },
  getWithFolders: async (params, cancelToken) => {
    const route = generateUrl(params, '/classes/getWithFolders');
    return await api.get(route, { cancelToken });
  },
  generateJoinCode: async () => {
    return await api.get('/classes/generateJoinCode');
  },
  deleteClass: async (values) => {
    return await api.post('/classes/deleteClass', values);
  },
  duplicateClass: async (values) => {
    return await api.post('/classes/duplicateClass', values);
  },
  getStudentsRepositories: async (params) => {
    return await api.get('/classes/getStudentsRepositories', { params });
  },
  addStudent: async (values) => {
    return await api.post('/classes/addStudent', values);
  },
  addStudents: async (values) => {
    return await api.post('/classes/addStudents', values);
  },
  getStudents: async (params) => {
    return await api.get('/classes/getStudents', { params });
  },
  getClassRepositories: async (values) => {
    return await api.post('/classes/getClassRepositories', values);
  },
  removeStudent: async (values) => {
    return await api.post('/classes/removeStudent', values);
  },
  addRepository: async (values) => {
    return await api.post('/classes/addRepository', values);
  },
  removeRepository: async (values) => {
    return await api.post('/classes/removeRepository', values);
  },
  getStudentLoginHistory: async(studentID: number): Promise<LoginHistoryItemDTO[]> => {
    const resp =  await api.get('/classes/getStudentLoginHistory', {params: {studentID}});

    return resp.data.map((partialItem) => ({
      ...partialItem,
      login: moment(partialItem.login),
      logout: moment(partialItem.logout)
    }))
  },
  sendMailstudents: async (values) => {
    return await api.post('/mail/students', values);
  }
};

function generateUrl(params, baseUrl) {
  const ret = [];
  for (const key in params) {
    if (params[key] !== '') {
      ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
    }
  }
  const paramString = ret.join('&');
  return paramString ? baseUrl + '?' + paramString : baseUrl;
}
